const state = {
    expandedLocationIds: [],
    scrollPosition: 0,
    selectedShift: 1,
    savedCurrentPage: 1,
};

const mutations = {
    EXPAND_LOCATION(state, id) {
        if (Number.isInteger(id) && !state.expandedLocationIds.includes(id)) {
            state.expandedLocationIds.push(id);
        }
    },
    COLLAPSE_LOCATION(state, id) {
        if (Number.isInteger(id)) {
            state.expandedLocationIds = state.expandedLocationIds.filter(locationId => locationId !== id);
        }
    },
    COLLAPSE_ALL_LOCATIONS(state) {
        state.expandedLocationIds = [];
    },
    SAVE_SCROLL_POSITION_AND_PAGE(state, { scrollPosition, savedCurrentPage }) {
        if (Number.isInteger(scrollPosition)) {
            state.scrollPosition = scrollPosition;
        }
        state.savedCurrentPage = savedCurrentPage;
    },
    SAVE_SHIFT(state, shift) {
        if (Number.isInteger(shift)) {
            state.selectedShift = shift;
        }
    },
};

export default {
    mutations,
    namespaced: true,
    state,
};
